const formatQuestionId = (id) => {
  if (String(id).startsWith('new')) return {}

  return { id: Number(id) }
}

const formatAnswerChoicesValues = (answerChoices) => {
  if (!answerChoices || !answerChoices.length) return {}

  return { answer_choices: answerChoices.map((answerChoice) => (answerChoice.choice)) }
}

const formatInviteeQuestionsValues = (questions) => questions.map((question) => ({
  ...formatQuestionId(question.id),
  ...formatAnswerChoicesValues(question.answerChoices),
  name: question.name,
  enabled: question.enabled,
  required: question.required,
  include_other: question.include_other,
  format: question.format,
  position: question.position,
  _destroy: question._destroy,
}))

export const formatValuesToServerData = (values) => ({
  custom_fields_attributes: formatInviteeQuestionsValues(values.inviteeQuestions)
})
